import { GET_LEGAL_NAMES, LEGAL_NAMES_ERROR } from 'src/actions/types'

const initialState = {
  legalNames: [],
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_LEGAL_NAMES:
      return {
        ...state,
        legalNames: payload,
        loading: false,
      }
    case LEGAL_NAMES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
